import AppButtonRadioGroup from "@/components/AppButtonRadioGroup";
export default {
  name: 'DatePickerRange',
  emits: ['update:modelValue'],
  components: {
    AppButtonRadioGroup
  },
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    range: {
      type: Object,
      default: () => {}
    },
    options: {
      type: Array
    },
    isCompare: {
      type: Boolean,
      default: false
    },
    hoverDate: {
      type: Object,
      default: () => {}
    },
    dateRange: {
      type: Object
    },
    active: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      startSelected: false,
      endSelected: false
    };
  },
  computed: {
    selected: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    }
  }
};